import React from 'react'

import { COLOR } from '../.../../../../themes'

const Bullet = ({ colorTheme, width, height }) => (
  <div
    className='bullet'
    style={{
      width: width || 16,
      height: height || 16,
      backgroundColor: colorTheme || COLOR.GOLD_1,
    }}
  />
)

export default Bullet
